import React, { useState } from 'react'
import { Button, Radio } from 'antd';
import StakeConfigurePlanWrapper from './style'

const StakeConfigurePlan = ({ exchange, handleProceed }) => {
    const [type, setType] = useState(exchange.type)
    const handleChange = (e) => {
        if (e.target.value === 'Cloud') {
            setType('Cloud');
        } else if (e.target.value === 'DIY') {
            setType('DIY');
        }  
        // else if (e.target.value === 'Enterprise'){
        //     setType('Enterprise');
        // } 
    };
    return (
        <StakeConfigurePlanWrapper>
            <div className="title">
                Configure plan
            </div>
            <div>
                <Radio.Group
                    name="domainType"
                    onChange={handleChange}
                    value={type}
                >
                    <Radio value="Cloud" >
                        Cloud exchange
                    </Radio>
                    <Radio value="DIY">
                        DIY
                    </Radio>
                    {/* <Radio value="Enterprise">
                        Enterprise
                    </Radio> */}
                </Radio.Group>
                <div className="btn-wrapper">
                    <Button type="primary" onClick={() => handleProceed(type)}>Proceed</Button>
                </div>
            </div>
        </StakeConfigurePlanWrapper>
    )
}

export default StakeConfigurePlan;